<template>
	<div class="consult">
		<div class="container">
			<div class="wenda">
				<p><span>1、</span>问：宣扬共享服务，致力于售后服务行业、资源浪费闲置等问题?</p>
				<p class="wenda-ansewr">答：以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护.</p>
			</div>
			
			<div class="wenda">
				<p><span>1、</span>问：宣扬共享服务，致力于售后服务行业、资源浪费闲置等问题?</p>
				<p class="wenda-ansewr">答：以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护.</p>
			</div>
			
			<div class="wenda">
				<p><span>1、</span>问：宣扬共享服务，致力于售后服务行业、资源浪费闲置等问题?</p>
				<p class="wenda-ansewr">答：以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护.</p>
			</div>
			
			<div class="wenda">
				<p><span>1、</span>问：宣扬共享服务，致力于售后服务行业、资源浪费闲置等问题?</p>
				<p class="wenda-ansewr">答：以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护.</p>
			</div>
			
			<div class="wenda">
				<p><span>1、</span>问：宣扬共享服务，致力于售后服务行业、资源浪费闲置等问题?</p>
				<p class="wenda-ansewr">答：以售后服务为切入点，打造技术服务领域解决产品销售、配送安装、维修保养、紧急救援全方位跨行业的大型综合类的技术服务平台。目前天图极客平台已开通的服务类目有多种：
					安防、IT、汽车维护.</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		conponents:{},
		data(){
			return{
				msg:'consult'
			}
		}
	}
	
</script>

<style lang="less" scoped="scoped">
.consult{
	margin-top: 70px;
	.wenda{
		margin-bottom:25px;
		p{
			padding: 5px;
		}
		.wenda-ansewr{
			margin-left: 24px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ServiceCenter/Scom/Consult.vue